module.exports = __webpack_public_path__ + "img/Bénédicte Savoy.f4a552f2.jpg";